import React from 'react';
import OutlinedLoading from "acud-icon/es/icons/OutlinedLoading";

var LoadingIcon = function LoadingIcon() {
  return /*#__PURE__*/React.createElement(OutlinedLoading, {
    animation: "spin"
  });
};

export default LoadingIcon;